import '../css/index.css';
import {menu} from './shell';
import newsletter from './newsletter';
import searchOverlay from './search-overlay';
import navigation from './navigation';

newsletter();
searchOverlay();
navigation(menu);
